export const searchTypeEnum = {
  //达人
  Influencer: 'influencer',
  // 商品
  Products: 'products',
  // 视频
  Videos: 'videos',
  // 直播
  Lives: 'lives',
  // 小店
  Shops: 'shops'
}

export const SortTypeEnum = {
  // 升序
  Asc: 'asc',
  // 降序
  Desc: 'desc'
}

export interface MetaType {
  current_page: number
  from: number
  last_page: number
  links: []
  path: string
  per_page: number
  to: number
  total: number
}

export interface FilterItem {
  id: string
  key: string
  name: string
}

export interface FilterData {
  influencer_categories: FilterItem[]
  more_filters: {
    [key: string]: FilterItem[]
  }
  product_categories: FilterItem[]
  regions: FilterItem[]
}

export const enum LiveStatus {
  Over = 0,
  InProgress = 1
}

export const enum CollectStatus {
  UnStar = 0,
  Star = 1
}

export const enum InfluencerCertificateTypes {
  None = 0,
  Personal = 1,
  Enterprise = 2
}

export const enum SearchTypes {
  Influencer = 0,
  Product = 1,
  Video = 2,
  Live = 3,
  Shop = 4,
  Hashtag = 5
}

export const enum SellerTypes {
  Local = 1,
  CrossBorder = 2
}

export const enum UserTypes {
  Unknown = -1,
  Internal = 0,
  Normal = 1,
  Proxy = 2
}

export const MemberEdition = {
  Free: 'free',
  Basic: 'basic',
  Pro: 'pro',
  Enterprise: 'enterprise'
}

export const enum OrderStatus {
  Created = 10,
  Paid = 20,
  Closed = 100,
  Refunded = 30
}

export const influencersLeaderboardTabKeys = {
  followers: 'followers',
  followerGrowth: 'follower-growth',
  salesChampion: 'sales-champion',
  darkHorseCreators: 'dark-horse-creators',
  darkHorseSellers: 'dark-horse-sellers',
  hotLive: 'hot-live',
  mostViewsLive: 'most-views-live'
}

export const productsLeaderboardTabKeys = {
  topSold: 'top-sold',
  hotPromoted: 'hot-sell',
  newProducts: 'new-products'
}

export const liveLeaderboardTabKeys = {
  mostViewed: 'most-viewed',
  topSold: 'top-sold',
  live: 'live'
}

export const shopLeaderboardTabKeys = {
  local: 'local',
  crossBorder: 'cross-border'
}

export const favoritesTabKeys = {
  influencers: 'influencers',
  videos: 'videos',
  products: 'products',
  lives: 'lives',
  shops: 'shops'
}

export const analysisTabKeys = {
  influencers: 'influencers',
  products: 'products',
  country: 'country'
}

export const videoLeaderboardTabKeys = {
  topVideos: 'top-videos',
  topSellingVideos: 'top-selling-videos',
  topHashtags: 'top-hashtags'
}

export const userTabKeys = {
  setting: 'setting',
  invite: 'invite',
  bill: 'bill',
  team: 'team'
}
